export const SUBSCRIPTION_UPGRADE_AB_TEST_KEY = 'subscription:upgrade-flow';
export const SUBSCRIPTION_WALLET_PAYMENT = 'subscription:wallet-payment';
export const SUBSCRIPTION_METADATA_COLLECTION = 'subscription:metadata-collection';